import api from '@/api'
import {
  SET_CLIENT_SYSTEM_NOTICE_LIST,
  SET_CLIENT_SYSTEM_NOTICE_LIST_PAGE_COUNT,
} from './mutation-types'

const state = {
  pageSize: 10,
  pageCount: 0,
  noticeList: [],
}

const mutations = {
  [SET_CLIENT_SYSTEM_NOTICE_LIST] (state, params) {
    state.noticeList = params
  },
  [SET_CLIENT_SYSTEM_NOTICE_LIST_PAGE_COUNT] (state, params) {
    state.pageCount = params
  },
}

const actions = {
  // 获取客户端系统通知列表
  async getClientSystemNoticeList ({state, commit}, payload) {
    let params = {
      pageSize: state.pageSize,
      pageNum: payload.pageNum,
    }
    try {
      const {data: {items, pageCount}} = await api.deployApi.getClientSystemNotice(params)
      if (payload.type === 'scrollAdd') {
        commit(SET_CLIENT_SYSTEM_NOTICE_LIST, [...state.noticeList, ...items])
      } else {
        commit(SET_CLIENT_SYSTEM_NOTICE_LIST, items)
      }
      commit(SET_CLIENT_SYSTEM_NOTICE_LIST_PAGE_COUNT, pageCount)
    } catch (error) {
      return error
    }
  },
  // 刷新客户端系统通知列表
  refreshClientSystemNoticeList ({dispatch}) {
    dispatch('getClientSystemNoticeList', {pageNum: 1, type: 'refresh'})
  },
  // 新增客户端推广通知
  async addClientSystemNotice ({dispatch}, payload) {
    const result = await api.deployApi.addClientSystemNotice(payload)
    dispatch('refreshClientSystemNoticeList')
    return result
  },
  // 编辑客户端推广通知
  async editClientSystemNotice ({dispatch}, payload) {
    const result = await api.deployApi.updateClientSystemNotice(payload)
    dispatch('refreshClientSystemNoticeList')
    return result
  },
  // 删除客户端推广通知
  async deleteClientSystemNotice ({dispatch}, payload) {
    const result = await api.deployApi.deleteClientSystemNotice(payload)
    dispatch('refreshClientSystemNoticeList')
    return result
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
